import { Chore } from '../types';

export const chores: Chore[] = [
  {
    id: 'basement-bathroom',
    task: 'Clean basement bathroom',
    frequency: 'Weekly',
    timeMinutes: 12,
    subtasks: [
      { id: 'basement-toilet', task: 'Clean basement bathroom toilet', frequency: 'Weekly', timeMinutes: 2 },
      { id: 'basement-floor', task: 'Clean basement bathroom floor', frequency: 'Weekly', timeMinutes: 2 },
      { id: 'basement-sink', task: 'Clean basement bathroom sink', frequency: 'Weekly', timeMinutes: 2 },
      { id: 'basement-counter', task: 'Clean basement bathroom counter', frequency: 'Weekly', timeMinutes: 2 },
      { id: 'basement-mirror', task: 'Clean basement bathroom mirror', frequency: 'Weekly', timeMinutes: 2 },
      { id: 'basement-trash', task: 'Take basement bathroom trash out', frequency: 'Weekly', timeMinutes: 2 },
    ]
  },
  {
    id: 'main-floor-bathroom',
    task: 'Clean main floor bathroom',
    frequency: 'Weekly',
    timeMinutes: 12,
    subtasks: [
      { id: 'main-toilet', task: 'Clean main floor bathroom toilet', frequency: 'Weekly', timeMinutes: 2 },
      { id: 'main-floor', task: 'Clean main floor bathroom floor', frequency: 'Weekly', timeMinutes: 2 },
      { id: 'main-sink', task: 'Clean main floor bathroom sink', frequency: 'Weekly', timeMinutes: 2 },
      { id: 'main-counter', task: 'Clean main floor bathroom counter', frequency: 'Weekly', timeMinutes: 2 },
      { id: 'main-mirror', task: 'Clean main floor bathroom mirror', frequency: 'Weekly', timeMinutes: 2 },
      { id: 'main-trash', task: 'Take main floor bathroom trash out', frequency: 'Weekly', timeMinutes: 2 },
    ]
  },
  {
    id: 'kids-bathroom',
    task: 'Clean kids bathroom',
    frequency: 'Weekly',
    timeMinutes: 12,
    subtasks: [
      { id: 'kids-toilet', task: 'Clean kids bathroom toilet', frequency: 'Weekly', timeMinutes: 2 },
      { id: 'kids-floor', task: 'Clean kids bathroom floor', frequency: 'Weekly', timeMinutes: 2 },
      { id: 'kids-sink', task: 'Clean kids bathroom sink', frequency: 'Weekly', timeMinutes: 2 },
      { id: 'kids-counter', task: 'Clean kids bathroom counter', frequency: 'Weekly', timeMinutes: 2 },
      { id: 'kids-mirror', task: 'Clean kids bathroom mirror', frequency: 'Weekly', timeMinutes: 2 },
      { id: 'kids-trash', task: 'Take kids bathroom trash out', frequency: 'Weekly', timeMinutes: 2 },
    ]
  },
  {
    id: 'master-shower',
    task: 'Clean master shower',
    frequency: 'Monthly',
    timeMinutes: 20
  },
  {
    id: 'master-bathroom',
    task: 'Clean master bathroom',
    frequency: 'Weekly',
    timeMinutes: 12,
    subtasks: [
      { id: 'master-toilet', task: 'Clean master bathroom toilet', frequency: 'Weekly', timeMinutes: 2 },
      { id: 'master-floor', task: 'Clean master bathroom floor', frequency: 'Weekly', timeMinutes: 2 },
      { id: 'master-sink', task: 'Clean master bathroom sink', frequency: 'Weekly', timeMinutes: 2 },
      { id: 'master-counter', task: 'Clean master bathroom counter', frequency: 'Weekly', timeMinutes: 2 },
      { id: 'master-mirror', task: 'Clean master bathroom mirror', frequency: 'Weekly', timeMinutes: 2 },
      { id: 'master-trash', task: 'Take master bathroom trash out', frequency: 'Weekly', timeMinutes: 2 },
    ]
  },
  {
    id: 'kids-shower',
    task: 'Clean kids shower',
    frequency: 'Monthly',
    timeMinutes: 20
  },
  {
    id: 'robot-cleaner',
    task: 'Run robot floor cleaner - main floor',
    frequency: '3x Weekly',
    timeMinutes: 5
  },
  {
    id: 'sweep-mop',
    task: 'Sweep & mop main floor',
    frequency: 'Every 2 Weeks',
    timeMinutes: 20
  },
  {
    id: 'vacuum-basement',
    task: 'Vacuum basement',
    frequency: 'Weekly',
    timeMinutes: 15
  },
  {
    id: 'vacuum-upstairs',
    task: 'Vacuum upstairs',
    frequency: 'Weekly',
    timeMinutes: 15
  },
  {
    id: 'dog-poop',
    task: 'Pick up dog poop - front yard',
    frequency: '2x Weekly',
    timeMinutes: 15
  },
  {
    id: 'mow-lawn',
    task: 'Mow lawn',
    frequency: 'Every 2 Weeks',
    timeMinutes: 60
  },
  {
    id: 'kitchen-counter',
    task: 'Deep kitchen counter scrub',
    frequency: 'Weekly',
    timeMinutes: 10
  },
  {
    id: 'clean-car',
    task: 'Clean out car',
    frequency: 'Weekly',
    timeMinutes: 20
  }
]; 